import $ from 'jQuery';
import './machine_app_confirmation_modal.css';

export function showConfirmationModal({
  pTitle,
  pSubTitle,
  pInformationElement,
  pConfirmText,
  pOnConfirm,
  pOnCancel,
  pCancelText,
  pOnXClicked,
  pConfirmBtnTheme = '',
  pConfirmButtonStyleOverrides,
  pCancelBtnTheme = '',
  pAppendElement = undefined,
  pDisableX = false
}) {
  const lModalContainer = $('<div>').addClass('machineapp_confirmation_modal_container').appendTo(pAppendElement || 'body');
  const lModal = $('<div>').addClass('machineapp_confirmation_modal').appendTo(lModalContainer);
  const lHeader = $('<div>').addClass('machineapp_confirmation_modal_header').appendTo(lModal);
  const lFooter = $('<div>').addClass('machineapp_confirmation_modal_footer').appendTo(lModal);

  pTitle && $('<div>')
    .addClass('machineapp_confirmation_modal_title')
    .text(pTitle)
    .appendTo(lHeader);
  pSubTitle && $('<div>')
    .addClass('machineapp_confirmation_modal_subtitle')
    .css('text-align', 'center')
    .text(pSubTitle)
    .appendTo(lHeader);
  pInformationElement && $('<div>')
    .addClass('machineapp_confirmation_modal_subtitle')
    .append(pInformationElement)
    .appendTo(lHeader);
  pCancelText && $('<button>')
    .addClass('machineapp_confirmation_modal_cancel_button ' + pCancelBtnTheme)
    .text(pCancelText)
    .appendTo(lFooter)
    .click(() => {
      if(pOnCancel) {
        pOnCancel();
      }
      lModalContainer.remove();
    });
  pConfirmText && $('<button>')
    .addClass('machineapp_confirmation_modal_confirm_button ' + pConfirmBtnTheme)
    .text(pConfirmText)
    .appendTo(lFooter)
    .click(function() { pOnConfirm(); lModalContainer.remove(); })
    .css(pConfirmButtonStyleOverrides || {}).focus();

  //x close button
  if (!pDisableX) {
    $('<div>')
      .addClass('icon-close machineapp_confirmation_modal_exitx')
      .appendTo(lModal)
      .click(() => {
        if(pOnXClicked) {
          pOnXClicked();
        }
        else if (pOnCancel){
          pOnCancel();
        }
        lModalContainer.remove();
      });
  }

  return lModalContainer;
}

export const machineAppWidgets = {
  showConfirmationModal: showConfirmationModal
};
